import editNode from './edit-node';

const editImage = editNode;
editImage.useRangeRect = false;

export default editImage;